var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"navigation-container"},[_c('Header',{staticClass:"navigation-box"}),_c('div',{staticClass:"shadow-bar",style:({ opacity : _vm.showBackground ? '1':'0'})})],1),_c('Sidebar'),_c('router-view'),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }